import { render, staticRenderFns } from "./ModalAddLot.vue?vue&type=template&id=b5d47118&scoped=true"
import script from "./ModalAddLot.vue?vue&type=script&lang=js"
export * from "./ModalAddLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d47118",
  null
  
)

export default component.exports